import { render, staticRenderFns } from "./add-edit-cohort.vue?vue&type=template&id=39eb7b70&scoped=true&"
import script from "./add-edit-cohort.vue?vue&type=script&lang=js&"
export * from "./add-edit-cohort.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-cohort.vue?vue&type=style&index=0&id=39eb7b70&scoped=true&lang=scss&"
import style1 from "./styles/add-edit-multi-consent.scss?vue&type=style&index=1&id=39eb7b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb7b70",
  null
  
)

component.options.__file = "add-edit-cohort.vue"
export default component.exports